<template>
    <v-row class="ma-n1">
        <v-col class="pa-1" cols="6" md="auto">
            <v-text-field label="기간검색(시작일)" :value="duration[0]" type="date" max="2999-12-31" v-bind="attrs_input" @input="(value) => setAt(0, value)" />
        </v-col>
        <v-col class="pa-1" cols="6" md="auto">
            <v-text-field label="기간검색(종료일)" :value="duration[1]" type="date" max="2999-12-31" v-bind="attrs_input" @input="(value) => setAt(1, value)" />
        </v-col>
        <v-col class="pa-1" cols="12" md="auto">
            <search-duration-type :value="duration" @input="onType" />
        </v-col>
    </v-row>
</template>

<script>
import { attrs_input } from "@/assets/variables";

import { initDuration } from "./search-duration";
import SearchDurationType from "./search-duration-type.vue";

// 날짜칸을 지우는 중이면 "" 가 들어온다. 그 밖의 반쪽짜리 값이 서버로 나가면
// 기간조건이 Invalid Date 로 조립되므로, 온전한 날짜일 때만 내보낸다.
const isDate = (value) => !value || /^\d{4}-\d{2}-\d{2}$/.test(value);

export default {
    components: {
        SearchDurationType,
    },
    props: {
        /** @type {import('vue').PropType<[string, string]>} */
        value: { type: Array, default: () => initDuration() },
    },
    data: () => ({
        duration: initDuration(),

        attrs_input,
    }),
    methods: {
        sync() {
            this.duration = [...(this.value || initDuration())];
        },
        setAt(index, value) {
            // Vue2 는 배열 원소 직접대입을 감지하지 못한다 — $set 으로 바꾼다.
            this.$set(this.duration, index, value);
            this.emit();
        },
        // 연간/월간/일간 버튼은 구간을 통째로 바꾼다 — v-model 과 섞으면 대입순서가 꼬여 따로 받는다.
        onType(value) {
            this.duration = [...(value || [])];
            this.emit();
        },
        emit() {
            if (!this.duration.every(isDate)) return;
            this.$emit("input", [...this.duration]);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped></style>
